import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row position-fixed w-100 border-top bottom-actions bg-white" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomActionsContainer',
  props: {
    col: { default: "col-10" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "children")
  ]))
}
}

})